import { render } from "./auto-reply.vue?vue&type=template&id=21a1902e"
import script from "./auto-reply.vue?vue&type=script&lang=js"
export * from "./auto-reply.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\CT\\Crm-Xmarks\\crm-waha\\crm-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__